import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableLoading,
} from "../../components";

import "./index.sass";

const AreaScreen = () => {
  const { requestArea, setRequestArea, resultArea } = React.useContext(
    Context.AreaScreen
  );

  return (
    <CustomView.Container id="work-time-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          <Components.Create />

          {/* <Components.Filter /> */}
          {/* <Components.Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        {resultArea?.status === "loading" ? (
          <TableLoading isTable={false} />
        ) : (
          <Components.Body data={resultArea?.data?.result?.docs} />
        )}
      </div>

      {resultArea?.status === "success" &&
        resultArea?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestArea?.page}
              totalPages={resultArea?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestArea!({ ...requestArea, page })
              }
            />
          </div>
        )}
      <Components.Update />
      <Components.Delete />
    </CustomView.Container>
  );
};

export default AreaScreen;
